import { render } from "./HomeworkTimeline.vue?vue&type=template&id=5c85c629&scoped=true"
import script from "./HomeworkTimeline.vue?vue&type=script&lang=js"
export * from "./HomeworkTimeline.vue?vue&type=script&lang=js"

import "./HomeworkTimeline.vue?vue&type=style&index=0&id=5c85c629&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c85c629"]])

export default __exports__